<!-- 收录线索弹窗 -->
<template>
  <div class="mask" v-if="show">
    <div class="wrapper">
      <div class="headline">
        <div class="filter">
          <p class="title">{{title}}</p>
        </div>
        <img src="@assets/img/interview/close.svg" alt="close" class="close" @click="close()">
      </div>
      <div class="filter-container">
        <div class="mediaType-container">
          <p>{{list_search.title}}</p>
          <ul>
            <li v-for="(item, index) in list_search.list" :key="index" @click="changeDay(index)" :class="{on: item.selected}">{{item.title}}</li>
          </ul>
        </div>
        <globalFilter ref="globalFilter" />
      </div>
      <div :class="{container: true,empty: list.length === 0}" ref="container">
        <empty :msg="'暂无收录数据'" style="margin-top: -18px" v-if="list && list.length === 0" />
        <div :class="{content: true, locateDom: l.locate}" v-for="(l, i) in list" :key="i">
          <div :class="{item: true, including: l.status == 3 || l.status == 1}">
            <span class="name">
              <span v-html="l.title"></span>
            </span>
            <span class="timeSection time1">
              <img src="@assets/img/common/time.svg" alt="time">
              <span class="time">
                <span>{{l.day}}</span>
                <span>{{l.time}}</span>
              </span>
            </span>
            <span v-if="l.status == 1" class="timeSection record">
              入库中
            </span>
            <span v-if="l.status == 3" class="timeSection record">
              正在收录
            </span>
            <span v-if="l.status != 1 && l.status != 3" class="timeSection">
              等待收录
            </span>

            <div class="publiserBtn">
              <span @click="streamCut(l.id, l.originUrl, l.title)" v-if="(l.status == 3 || l.status == 1) && has_bsedit_role && l.originUrl != ''" class="publiser">
                收录剪辑
              </span>
              <span @click="toScube(l.scube_url)" v-if="l.scube_url != ''" class="publiser on">
                去拆条
              </span>
            </div>
            

          </div>
        </div>
      </div>
      <div class="bottomLine">
        <!-- <p @click="getList" class="btn">加载更多</p> -->
      </div>
    </div>
  </div>
</template>

<script>
import common from '@common/common'
import {apis} from '@common/config'
import empty from '@components/empty'
import globalFilter from "@components/globalFilter"

export default {
  name: 'withInterview',
  components: {
    globalFilter,
    empty
  },
  props: {
    from: {
      type: Number, // 来自模块
      default: 2  // 2:线索， 3:报道
    }
  },
  data() {
    return {
      days: 0,
      key_words: '',
      list_search: {},
      title: '正在收录',
      show: false,
      icons: {
        up: require('../assets/img/interview/up.png'),
        down: require('../assets/img/interview/down.png')
      },
      options: [],
      search: {
        key: '',
        word: ''
      },
      list: [],
      selected: {},
      selectedItem: {},
      expand: false,
      page: {
        pageIndex: 1,
        pageSize: 20,
        totalPage: null
      },
      scrollLock: false,
      has_bsedit_role: false
    }
  },
  watch: {
    show(to) {
      // console.log(to)
      if(to){
        this.$nextTick(() => {
          let el = document.getElementsByClassName('locateDom')[0]
          if(el){
            this.ScrollToControl()
          }
        })
      }
    }
  },
  methods: {
    changeDay(index) {
      let days = 0
      this.list_search.list.forEach((el,key) => {
        if(index == key){
          el.selected = !el.selected
          if(el.selected){
            days = el.key
          }else{
            days = 0
          }
        }else{
          el.selected = false
        }
      })
      this.days = days
      this.page.pageIndex = 1
      this.getList('search')
    },
    generateSearchs(data) {
      console.log("generateSearchs data", data);
      // 整理搜索栏数据
      const types = data.map(i => {
        return {
          name: i.title,
          code: i.key,
          selected: i.selected
        };
      });

      const filterData = {
        types: types,
        callback: o => {
          this.getSearch(o);
        }
      };
      this.$refs.globalFilter.getData(filterData);
    },
    getSearch(d) {
      console.log("getSearch d", d);
      // 接收搜索框数据
      this.key_words = d.key_words;
      this.page.pageIndex = 1;
      // // 让list回到顶部
      // this.$refs.listContainer.scrollTop = 0;
      this.getList('search');
    },
    ScrollToControl() {
      let el = document.getElementsByClassName('locateDom')[0]
      el.scrollIntoView()
    },
    toScube(url) {
      window.open(url)
      // window.location.href = url
    },
    streamCut(id,url,title,idstring) {
      if(idstring == undefined){
        idstring = ''
      }
      let info = {
          title: title,
          id: id,
          url: url,
          idstring: idstring
      }
      this.$cloudEditConfirmStream(info).then((res) => {
        if(res!=999){
          let unid = common.getUnid();
          let uid = common.getUid();
          window.location.href = res.meisheurl
        }
        // window.open("http://editortest.smgtech.net/App?token="+uid+"--"+unid+"&projectId=" + res.id)
      })
    },
    newInsert() {
      const info = {
          idstring: this.info.id,
          type: 2,
          title: this.info.title,
          stream_url: this.stream_url,
          ratio: this.ratio
      }
      common.myFetch(apis.editvideoInsert, {method: 'post', data: info})
      .then((data) => {
          if (!data) return
          this.$emit('refresh')
          this.close();
      })
    },
    close() {
      this.show = false
    },
    open(title) {
      this.show = true
      this.title = title
      this.$nextTick(() => {
        this.getList()
        this.handleScroll()
      })
    },
    getList(hint) {
      this.scrollLock = true
      if (this.page.totalPage && this.page.pageIndex > this.page.totalPage) return

      const info = {
        days: this.days,
        key_words: this.key_words,
        page: this.page.pageIndex,
        pagesize: this.page.pageSize
      }

      common.myFetch(apis.clue_includes, info)
      .then((data) => {
        console.log(data)
        this.has_bsedit_role = data.has_bsedit_role
        this.page.pageIndex += 1
        if(hint == 'search'){
          this.list = data.list
        }else{
          this.list = (this.list || []).concat(data.list)
        }
        this.page.totalPage = data.page.page_count
        this.scrollLock = false
        data.params.list_search[0].list.forEach(el => {
          el.select = false;
        });
        this.list_search = data.params.list_search[0];
        this.generateSearchs(data.params.top_search.option.list);

        this.$nextTick(() => {
          this.ScrollToControl()
        })
      })
    },
    handleScroll() {
      const container = this.$refs.container
      container.addEventListener('scroll', () => {
        const scrolltop = container.scrollTop;
        const scrollheight = container.scrollHeight;
        const clientheight = container.clientHeight;

        if (scrolltop + clientheight >= scrollheight) {
          if (this.scrollLock) return
          this.getList()
        }
      }, false)
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../assets/css/global.less';
  .mediaType-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    height: 40px;

    p {
      color: #41B48C;
      font-weight: bold;
      margin-right: 20px;
    }

    ul {
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 100%;

      li {
        width: 80px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        font-size: 14px;
        color: #829191;
        margin-right: 8px;
        user-select: none;
        cursor: pointer;

        &.on {
          color: @green;
          border: 1px solid @green;
          box-sizing: border-box;
          border-radius: 20px;
        }
      }
    }
  }

  .mask {
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    position: fixed;
    z-index: 1111;
    background-color: rgba(0,0,0,0.70);
    display: flex;
    align-items: center;
    justify-content: center;
    .wrapper {
      .boxOuter;
      // width: 880px;
      width: 970px;
      height: 90%;
      max-height: 796px;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      .headline {
        height: 70px;
        padding: 0 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .filter {
          height: 70px;
          display: flex;
          align-items: center;
          .title {
            font-size: 24px;
            line-height: 33px;
            color: @dark;
            font-weight: bold;
          }
        }
        .close {
          cursor: pointer;
        }
      }

      .filter-container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 0 0 0 30px;
        box-sizing: border-box;
        margin-bottom: 20px;
      }

      .container {
        flex: 1;
        overflow-y: auto;

        &.empty {
          display: flex;
          align-items: center;
        }

        &::-webkit-scrollbar {
            width: 3px;
        }
        &::-webkit-scrollbar-thumb {
            background: #41B48C;
            border-radius: 2px;
        } 
        .content {
          padding: 0 30px;
          cursor: pointer;
          &:hover {
            background-color: rgba(185,195,195,0.15);
          }
          .item {
            height: 60px;
            border-bottom: 1px solid #dcdcdc;
            display: flex;
            align-items: center;
            .name {
              flex: 1;
              font-size: 16px;
              color: @sub;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            &:hover {
              .name {
                color: #41B48C !important;
              }

              .timeSection {
                color: #41B48C !important;
              }
            }
            .publiserBtn {
              display: flex;
              align-items: center;
              width: 140px;
              .publiser {
                display: flex;
                justify-content: center;
                width: 70px;
                height: 30px;
                background: #41B48C;
                box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.1);
                border-radius: 4px;
                font-size: 14px;
                font-weight: bold;
                color: #FFFFFF !important;
                line-height: 30px;
                text-align: center;

                &.on {
                  width: 60px !important;
                  background-color: #FFF;
                  color: #829191 !important;
                  margin-left: 10px;
                }
              }


            }
            .timeSection {
              width: 60px;
              margin-right: 30px;
              font-size: 14px;
              line-height: 20px;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #858585;

              &.time1 {
                width: 110px;
                display: flex;
                flex-direction: row;
                align-items: center;
                margin-right: 80px;

                img {
                  margin-right: 14px;
                }

                .time {
                  display: flex;
                  flex-direction: column;
                  color: #B9C3C3;
                  font-weight: bold;
                  font-size: 14px;
                  line-height: 16px;
                }
              }

              &.in {
                color: #41B48C;
              }
              &.record {
                color: #050F0F;
              }
              .time {
                width: 92px;
                .numberFont;
                font-size: 14px;
                color: @sub;
                text-align: right;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
              }
            }
          }
          .collecting {
            // 入库中
            .name {
              color: @green !important;
            }
            .publiser {
              color: @green !important;
            }
          }
          .including {
            // 正在收录
            .name {
              color: @dark !important;
            }
            .publiser {
              color: @dark !important;
            }
          }
        }
        .content:last-child {
          .item {
            border: none;
          }
        }
        .selected {
          background-color: rgba(65,180,140,0.15) !important;
          span {
            color: @green !important;
          }
        }
      }

      .bottomLine {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 90px;

        .btn {
          width: 120px;
          height: 40px;
          background: #41B48C;
          border-radius: 20px;
          font-size: 14px;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 40px;
          text-align: center;
          user-select: none;
          cursor: pointer;
        }
      }
    }
  }
</style>

<style>
  .wrapper .content .name span em {
    font-style: normal;
    color: #41B48C;
  }
</style>
